import CertificateTemplateLayout from './certificate_template_layout.jsx';

const CertificateTemplatePage = () => {
  return (
      <CertificateTemplateLayout />
  );
};

export default CertificateTemplatePage;